import { CheckCircle } from "lucide-react";

const HIGHLIGHTS = [
  "Contadora pública matriculada",
  "Atención 100% remota",
  "Reuniones por videollamada",
  "Gestión digital eficiente",
  "Asesoramiento personalizado",
  "Seguimiento profesional acorde a tus necesidades",
];

export const About = () => {
  return (
    <section
      id="sobre-mi"
      data-testid="about-section"
      aria-label="Sobre Bárbara Cargnello, contadora pública"
      className="bg-white py-16 md:py-24"
    >
      <div className="container mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 md:gap-16 lg:grid-cols-2">
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-xl">
              <img
                src="/images/sobre-mi.webp"
                alt="Bárbara Cargnello, contadora pública"
                loading="lazy"
                width="600"
                height="520"
                className="h-[400px] w-full object-cover md:h-[520px]"
              />
            </div>
          </div>

          <div>
            <span className="mb-3 inline-block font-poppins text-sm font-medium uppercase tracking-wide text-gold">
              Sobre mí
            </span>
            <h2 className="mb-6 font-poppins text-3xl font-semibold text-navy-900 md:text-4xl">
              Bárbara Cargnello
            </h2>
            <div className="mb-8 space-y-4 font-inter text-base leading-relaxed text-navy-700 md:text-lg">
              <p>
                Soy <strong>contadora pública matriculada</strong> y tengo más
                de 10 años de experiencia acompañando emprendedores,
                profesionales y pymes que buscan un servicio personalizado y a
                medida de sus necesidades.
              </p>
              <p>
                Te ayudo a mantener tus impuestos al día y optimizar tu gestión
                contable para que puedas enfocarte en hacer crecer tu negocio.
              </p>
              <p>
                Trabajo de forma remota, con reuniones por videollamada,
                documentación digital y seguimiento profesional acorde a tus
                necesidades.
              </p>
            </div>

            <ul className="space-y-3" aria-label="Características del servicio">
              {HIGHLIGHTS.map((item) => (
                <li key={item} className="flex items-center gap-3">
                  <CheckCircle
                    className="h-5 w-5 flex-shrink-0 text-gold"
                    strokeWidth={1.5}
                  />
                  <span className="font-inter text-base text-navy-800">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

